import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogRemoveMedConfirm } from './model';

@Component({
  selector: 'app-remove-med-confirm',
  templateUrl: './remove-med-confirm.component.html',
  styleUrls: ['./remove-med-confirm.component.scss']
})
export class RemoveMedConfirmComponent implements OnInit {

  
  constructor(
    public dialogRef: MatDialogRef<RemoveMedConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogRemoveMedConfirm
  ) {
  }

  ngOnInit(): void {
  }

  remove() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
